<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="svg-icon">
    <ellipse
      cx="12.06"
      cy="7.96"
      rx="6.59"
      ry="6.55"
      fill="none"
      stroke="currentColor"
      stroke-width="1.84"
    />
    <path
      d="M6.85,13.13,1.07,18.87"
      fill="none"
      stroke="currentColor"
      stroke-width="1.84"
    />
  </svg>
</template>
